import { useRef } from "react";

const DescriptionField = ({ pageKey, handleDescriptionChange, page }) => {
  const textareaRefs = useRef({});

  const handleChange = (locale) => {
    const description = textareaRefs.current[`page_description_${locale}`]?.value || "";
    handleDescriptionChange(locale, description);
  };

  const availableLocales = window.available_locales || [];
  const localeCountryMapping = window.locale_country_mapping || {};

  const descriptionFieldTabs = availableLocales.map((locale, i) => {
    const classname = i === 0 ? "active" : "";
    return (
      <li key={locale} className={classname}>
        <a data-toggle="tab" href={`#tab-${pageKey}-${locale}`}>
          <span className={`flag-icon flag-icon-${localeCountryMapping[locale]}`}></span>
        </a>
      </li>
    );
  });

  const descriptionFieldContent = availableLocales.map((locale, i) => {
    const classname = i === 0 ? "active" : "";
    return (
      <div
        key={`description${locale}`}
        className={`tab-pane ${classname}`}
        id={`tab-${pageKey}-${locale}`}
      >
        <div className="panel-body">
          <textarea
            ref={(el) => (textareaRefs.current[`page_description_${locale}`] = el)}
            onChange={() => handleChange(locale)}
            className="form-control"
            value={page[`description_${locale}`] || ""}
          ></textarea>
          <p className="help-block">
            This description will be shown at the top of the page.
          </p>
        </div>
      </div>
    );
  });

  return (
    <div className="form-group">
      <label>Description</label>
      <div className="tabs-container">
        <ul className="nav nav-tabs">{descriptionFieldTabs}</ul>
        <div className="tab-content">{descriptionFieldContent}</div>
      </div>
    </div>
  );
};

export default DescriptionField;
